module.exports = __webpack_public_path__ + "dd6c177d56a2ad93c90c8bfd09ea1fb0.jpg";